function SePopup(triggerEl) {
    this.el = null;
    this.innerEl = null;
    this.triggerEl = triggerEl;
    this.initialized = false;
    this.bodyHadOverflow = false;

    this.triggerEl.addEventListener('click', e => {
        e.preventDefault();

        if (e.target.classList.contains('jsShowPopup')) this.show();
        else if (e.target.classList.contains('jsHideTrigger')) this.hideTrigger();
    });

    window.addEventListener('keyup', e => {
        if (e.key.toLowerCase() === 'escape') this.hide();
    });

    this.showTrigger();
}

SePopup.prototype._init = function() {
    this.initialized = true;

    // Create the popup
    this.el = document.createElement('div');
    this.el.classList.add('se-popup');
    this.el.classList.add('jsClosePopup');

    this.el.innerHTML = '' +
        '<div class="se-popup__inner">' +
            '<button class="se-popup__close-btn jsClosePopup">Close</button>' +
            '<span class="se-popup__title">' + JSON.parse(this.triggerEl.dataset.popupTitle) + '</span>' +
            '<div class="se-popup__content default-styles text-color-' + this.triggerEl.dataset.textColor + '">' + JSON.parse(this.triggerEl.dataset.popupContent) + '</div>' +
        '</div>'
    ;

    this.innerEl = this.el.querySelector('.se-popup__inner');
    this.innerEl.classList.add('text-color-' + this.triggerEl.dataset.textColor);
    this.innerEl.classList.add('bg-color-' + this.triggerEl.dataset.bgColor + '-1');

    const contentBtnEls = this.innerEl.querySelectorAll('.btn');
    contentBtnEls.forEach(el => {
        el.className = '';
        el.classList.add('btn');
        el.classList.add('btn--arrow');
        el.classList.add('text-color-' + this.triggerEl.dataset.bgColor + '-1');
        el.classList.add('bg-color-white');
    });

    document.body.appendChild(this.el);

    // Add event listeners
    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsClosePopup')) {
            e.preventDefault();
            this.hide();
        }
    });
};

SePopup.prototype.showTrigger = function() {
    const hideCookie = document.cookie.split(';').find(c => c.trim().startsWith('se_hide_popup_' + this.triggerEl.dataset.popupId));
    if (hideCookie) return;

    setTimeout(() => {
        gsap.timeline()
            .set(this.triggerEl, { opacity: 0, y: -20 })
            .add(() => {
                this.triggerEl.classList.add('visible');
                this.triggerEl.classList.add('no-transition');
            })
            .to(this.triggerEl, { duration: 0.5, opacity: 1, ease: 'power2.inOut' })
            .to(this.triggerEl, { duration: 0.8, y: 0, ease: 'Bounce.easeOut' }, '-=0.5')
            .add(_ => this.triggerEl.classList.remove('no-transition'))
            .add(() => {
                if (this.triggerEl.classList.contains('jsShowLarge')) {
                    const hideCookie = document.cookie.split(';').find(c => c.trim().startsWith('se_hide_init_popup_' + this.triggerEl.dataset.popupId));
                    if (!hideCookie) this.show();
                }
            })
        ;
    }, parseInt(this.triggerEl.dataset.appearTimeout) * 1000);
};

SePopup.prototype.show = function() {
    if (!this.initialized) this._init();

    this.bodyHadOverflow = document.body.classList.contains('no-overflow');
    document.body.classList.add('no-overflow');

    gsap.timeline()
        .set(this.el, { opacity: 0 })
        .set(this.innerEl, { scale: 0.9 })
        .add(() => this.el.classList.add('visible'))
        .to(this.el, { duration: 0.5, opacity: 1, ease: 'power2.inOut' })
        .to(this.innerEl, { duration: 0.5, scale: 1, ease: 'power2.inOut' }, '-=0.5')
        .set(this.el, { clearProps: 'all' })
    ;
};

SePopup.prototype.hide = function() {
    if (!this.initialized) return;
    if (this.triggerEl.classList.contains('jsShowLarge')) document.cookie = 'se_hide_init_popup_' + this.triggerEl.dataset.popupId + '=true; path=/; SameSite=Lax';

    // Remove the overflow from the body
    if (!this.bodyHadOverflow) {
        document.body.classList.remove('no-overflow');
    }

    gsap.timeline()
        .to(this.el, { duration: 0.5, opacity: 0, ease: 'power2.inOut' })
        .to(this.innerEl, { duration: 0.5, scale: 0.9, ease: 'power2.inOut' }, '-=0.5')
        .add(() => this.el.classList.remove('visible'))
        .set(this.el, { clearProps: 'all' })
    ;
};

SePopup.prototype.hideTrigger = function() {
    // Set a cookie so we remember to not show it again
    document.cookie = 'se_hide_popup_' + this.triggerEl.dataset.popupId + '=true; path=/; SameSite=Lax';

    // Hide the trigger element
    this.triggerEl.classList.add('no-transition');

    gsap.timeline()
        .to(this.triggerEl, { duration: 0.5, x: 100, opacity: 0, ease: 'power2.inOut' })
        .set(this.triggerEl, { display: 'none' })
    ;
};

(function() {
    const popupTriggerEls = document.querySelectorAll('.jsPopupTrigger');
    popupTriggerEls.forEach(el => new SePopup(el));
})();